import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { ColorModeProvider } from "@chakra-ui/color-mode";
import { createContext, merge } from "@chakra-ui/utils";
import { ThemeContext } from "@emotion/core";
import * as React from "react";
import { GlobalStyle } from "./global";
export function ThemeProvider(props) {
  var children = props.children,
      theme = props.theme;
  var outerTheme = React.useContext(ThemeContext);
  var mergedTheme = merge(outerTheme, theme);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: mergedTheme
  }, children);
}
export function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (!theme) {
    throw Error("useTheme must be used within a ThemeProvider");
  }

  return theme;
}
export function ChakraProvider(props) {
  var _theme$config, _theme$config2;

  var theme = props.theme,
      children = props.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ColorModeProvider, {
    defaultValue: (_theme$config = theme.config) == null ? void 0 : _theme$config.initialColorMode,
    useSystemColorMode: (_theme$config2 = theme.config) == null ? void 0 : _theme$config2.useInitialColorMode
  }, /*#__PURE__*/React.createElement(GlobalStyle, null), children));
}

var _createContext = createContext({
  strict: false,
  name: "ThemingContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    ThemingProvider = _createContext2[0],
    useThemingContext = _createContext2[1];

export { ThemingProvider, useThemingContext };